/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import styled from 'styled-components';

import { AnimatedLoadingPlaceholder } from '../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';

export const SafetyTipsLoadingUI = () => {
    return (
        <Container>
            <IconTitleWrapper>
                <AnimatedLoadingPlaceholder width={32} height='32px' radius={16} />
                <SafetyTipLoadingUI>
                    <AnimatedLoadingPlaceholder />
                </SafetyTipLoadingUI>
            </IconTitleWrapper>
            <SafetyTipLoadingUI isSubTextLoadingUI>
                <AnimatedLoadingPlaceholder />
            </SafetyTipLoadingUI>
            <SafetyTipLoadingUI isSubTextLoadingUI>
                <AnimatedLoadingPlaceholder />
            </SafetyTipLoadingUI>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 12px 8px;
`;

const IconTitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 121px;
    height: 100%;
`;

interface SafetyTipLoadingUIProps {
    isSubTextLoadingUI?: boolean;
}
const SafetyTipLoadingUI = styled.div<SafetyTipLoadingUIProps>`
    display: flex;
    flex-direction: row;
    height: 16px;
    width: 80px;
    ${({ isSubTextLoadingUI }) => isSubTextLoadingUI && `
        width: 75%;
        margin: 7px 0 0 42px;
    `};
`;
